// Shared building blocks for the lesson-style content pages.

export const PageShell = ({ eyebrow, title, subtitle, children, testId }) => (
  <div className="max-w-3xl mx-auto px-6 py-12" data-testid={testId}>
    <header className="mb-12">
      {eyebrow && (
        <span className="inline-block text-xs font-bold uppercase tracking-[0.16em] text-brand-orange mb-3">
          {eyebrow}
        </span>
      )}
      <h1 className="text-4xl md:text-5xl font-bold text-ink leading-tight mb-4">{title}</h1>
      {subtitle && <p className="text-lg text-ink-secondary leading-relaxed">{subtitle}</p>}
    </header>
    <div className="space-y-14">{children}</div>
  </div>
);

export const Section = ({ number, title, children }) => (
  <section>
    <div className="flex items-center gap-3 mb-5">
      {number != null && (
        <span className="w-7 h-7 rounded-lg bg-brand-teal text-white text-sm font-bold flex items-center justify-center shrink-0">
          {number}
        </span>
      )}
      <h2 className="text-2xl font-bold text-ink leading-tight">{title}</h2>
    </div>
    {children}
  </section>
);

export const Callout = ({ label, children, variant = 'teal' }) => {
  const styles =
    variant === 'orange'
      ? 'bg-brand-orange/[0.06] border-brand-orange'
      : 'bg-white border-brand-teal';
  const labelColor = variant === 'orange' ? 'text-brand-orange' : 'text-brand-teal';
  return (
    <div className={`rounded-2xl border-l-4 shadow-sm px-6 py-5 ${styles}`} data-testid="content-callout">
      {label && (
        <p className={`text-xs font-bold uppercase tracking-[0.14em] mb-1.5 ${labelColor}`}>{label}</p>
      )}
      <div className="text-ink leading-relaxed">{children}</div>
    </div>
  );
};
